
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 54 54"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FF492C","d":"M53.719 26.6c0 14.62-11.847 26.467-26.468 26.467C12.631 53.067.784 41.22.784 26.6.784 11.978 12.631.131 27.251.131 41.872.132 53.72 11.99 53.72 26.6"}}),_c('path',{attrs:{"fill":"#fff","d":"M38.707 22.28h-6.839v-.318c0-1.164.233-2.128.698-2.88.466-.762 1.271-1.429 2.435-2.022l.53-.264c.942-.477 1.185-.89 1.185-1.376 0-.583-.508-1.006-1.323-1.006-.974 0-1.704.508-2.213 1.535l-1.312-1.313c.286-.614.751-1.101 1.365-1.493a3.8 3.8 0 0 1 2.065-.582c.942 0 1.757.244 2.424.752.688.508 1.027 1.207 1.027 2.085 0 1.408-.794 2.266-2.276 3.028l-.836.424c-.89.444-1.324.847-1.451 1.556h4.521zm-.604 2.16h-7.485l-3.737 6.479h7.485l3.748 6.479 3.737-6.48zM27.527 35.249c-4.764 0-8.639-3.875-8.639-8.64 0-4.763 3.875-8.638 8.639-8.638l2.964-6.193a15.2 15.2 0 0 0-2.964-.286c-8.353 0-15.129 6.775-15.129 15.118 0 8.353 6.765 15.129 15.129 15.129a15.08 15.08 0 0 0 8.904-2.901l-3.282-5.675a8.62 8.62 0 0 1-5.622 2.086"}})])
          )
        }
      }
    